import styled1 from "./styled1";
window.styled = {
    ...styled1
}
export default styled